import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { IFundingMod } from '../IFundingMod';
import * as FundingModActions from './funding-mod.actions';

export const fundingModsFeatureKey = 'fundingMods';

export interface State extends EntityState<IFundingMod> {
    // additional entities state properties
}

export const adapter: EntityAdapter<IFundingMod> =
    createEntityAdapter<IFundingMod>({
        selectId: (model: IFundingMod) => model.FundingID
    });

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const fundingModReducer = createReducer(
    initialState,
    on(FundingModActions.addFundingMod, (state, action) =>
        adapter.addOne(action.fundingMod, state)
    ),
    on(FundingModActions.upsertFundingMod, (state, action) =>
        adapter.upsertOne(action.fundingMod, state)
    ),
    on(FundingModActions.addFundingMods, (state, action) =>
        adapter.addMany(action.fundingMods, state)
    ),
    on(FundingModActions.upsertFundingMods, (state, action) =>
        adapter.upsertMany(action.fundingMods, state)
    ),
    on(FundingModActions.updateFundingMod, (state, action) =>
        adapter.updateOne(action.fundingMod, state)
    ),
    on(FundingModActions.updateFundingMods, (state, action) =>
        adapter.updateMany(action.fundingMods, state)
    ),
    on(FundingModActions.deleteFundingMod, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(FundingModActions.deleteFundingMods, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(FundingModActions.loadFundingMods, (state, action) =>
        adapter.setAll(action.fundingMods, state)
    ),
    on(FundingModActions.clearFundingMods, state => adapter.removeAll(state))
);

export function reducer(state: State | undefined, action: Action) {
    return fundingModReducer(state, action);
}

export const selectFundingModState = createFeatureSelector<State>(
    fundingModsFeatureKey
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(selectFundingModState);
